import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Modal from 'components/modal/modal.component';
import Select from 'components/select/select.component';
import Button from '../../components/button/button.component';
import { ITransferData } from 'interfaces/applicant.interface';
import { updateTank } from '../../requests/dashboard.request';
import Loader from '../../components/loader/loader.component';
import './dashboard.style.scss';

interface IProps {
  handleClose: (kpuId?: number) => void;
  data: ITransferData;
}

const TransferModal: React.FC<IProps> = ({ handleClose, data }) => {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<Record<string, number | string>[]>([]);
  const [kpuId, setKpuId] = useState<number>();

  useEffect(() => {
    if (data?.kpuList && data.kpuList.length > 0) {
      const kpuList = data.kpuList
        .map((kpu) => ({ id: kpu.kpuId, name: kpu.name ?? kpu.kpuId }))
        .filter((item) => item.id !== data.tank.kpuId);
      setOptions(kpuList);
    }
  }, [data?.kpuList]);

  const handleChangeKpu = ({ target }: React.ChangeEvent<HTMLSelectElement>) => {
    setKpuId(+target.value);
  };

  const handleMoveTank = () => {
    setLoading(true);
    const updatedTank = { ...data.tank, kpuId };
    updateTank(updatedTank)
      .then((res) => {
        if (res.success) {
          toast.success('Резервуар успешно перемещен');
          handleClose(kpuId);
        } else {
          toast.error(res.error ?? 'Ошибка при перемещении резервуара');
        }
      })
      .catch(() => toast.error('Ошибка при перемещении резервуара'))
      .finally(() => setLoading(false));
  };

  return (
    <Modal width={'300px'} title={'Переместить резервуар'} onClose={() => handleClose()}>
      <Loader loading={loading}>
        <Select
          label={'КПУ'}
          name={'kpuId'}
          options={options}
          value={kpuId}
          onChange={handleChangeKpu}
        />
        <div className="transferModal__footer">
          <Button onClick={() => handleClose()} secondary>
            Отмена
          </Button>
          <Button onClick={handleMoveTank} primary>
            Переместить
          </Button>
        </div>
      </Loader>
    </Modal>
  );
};

export default TransferModal;
